import schedule from './schedule'
import distribution from './distribution'

export default {
  get: {
    method: 'get',
    url: '/client/journey/ID'
  },
  getVehicles: {
    method: 'get',
    url: '/client/journey/vehicles'
  },
  getJourneys: {
    method: 'get',
    url: '/client/journey/list'
  },
  schedule,
  distribution
}
